// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"ViewShortInShipmentTires_buttonsWrapper__3bNLi"};